import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { StyledCarouselHeadingArea } from './CarouselHeadingArea.styles';

/**
 * Wrapper for the Carousel heading text.
 *
 * @since 8.71.0
 */
export var CarouselHeadingArea = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledCarouselHeadingArea, _extends({
    ref: forwardedRef
  }, props));
});
CarouselHeadingArea.displayName = 'CarouselHeadingArea';